import { ChangeDetectionStrategy, Component, effect, input, signal, ViewChild } from '@angular/core';
import { LocationType } from 'angular-to-phaser';
import { Npc, Zone } from '../../dto';
import { AuthService } from '../../services/auth.service';
import { UIStateService } from '../../services/ui-state.service';
import { WorldService } from '../../services/world.service';
import { PageComponent } from '../base.component';
import { InteractorComponent } from '../ui/interactor/interactor.component';

@Component({
    selector: 'app-explore',
    templateUrl: './explore.component.html',
    styleUrls: ['./explore.component.scss'],
    host: { class: 'full-width' },
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExploreComponent extends PageComponent {

    public static route: string = "explore"

    public LocationType = LocationType;
    @ViewChild('interactor') interactor: InteractorComponent;

    // Unset when the route has no :zoneId segment (the top-level "/explore" world view).
    zoneId = input<string>();
    // Backed by a signal, not a plain field - every write happens inside the effect()/subscribe
    // below, never a template-bound handler. The getter keeps every zone.X read in the template
    // working unchanged.
    private zoneState = signal<Zone>(undefined);
    get zone(): Zone { return this.zoneState(); }
    selectedNpc: Npc = null;
    constructor(private worldService: WorldService, authService: AuthService, uiStateService: UIStateService) {
        super(authService, uiStateService);
        effect((onCleanup) => {
            const zoneId = this.zoneId();
            if (zoneId) {

                const zoneSub = this.worldService.getZone(zoneId).subscribe(zone => {
                    this.zoneState.set(zone);
                    if (this.zone.OwnerNpcExternalId) { //zone IS A npc (at their home)
                        const npcSub = this.worldService.retrieveNpcOptions(this.zone.OwnerNpcExternalId).subscribe(interaction => {
                            this.interactor.beginInteraction(interaction, this.zone.Name);
                        });
                        onCleanup(() => npcSub.unsubscribe());
                    } else if (this.zone.Interactive) {
                        const zoneOptionsSub = this.worldService.retrieveZoneOptions(this.zone.ExternalId).subscribe(interaction => {
                            this.interactor.beginInteraction(interaction, this.zone.Name);
                        });
                        onCleanup(() => zoneOptionsSub.unsubscribe());
                    }
                });
                onCleanup(() => zoneSub.unsubscribe());
            } else { //no parent zone = top level = THE WORLD
                this.zoneState.set(new Zone(<any>{
                    Name: "Explore the World!",
                    Description: "These are all the lands that have been discovered, where will you visit first?",
                    BackgroundImagePath: "world-background.png",
                    OutsideImagePath: "world-background.png"
                }));

                const worldSub = this.worldService.getWorld().subscribe(zones => {
                    this.zone.Zones = zones;
                    this.zoneState.set(new Zone(this.zone));
                });
                onCleanup(() => worldSub.unsubscribe());
            }
        });
    }

    activateNpc(npc: Npc) {
        this.selectedNpc = npc;
    }

}
